const readString = (value) => (typeof value === 'string' && value.trim() ? value.trim() : '');

const emptySandboxContextFields = () => ({
  active_overlay_id: null,
  workspace_snapshot_key: null,
  baseline_workspace_snapshot_key: null,
  parent_environment_snapshot_id: null,
  source_session_id: null,
  instance_preview_mode: null,
});

export const buildSandboxContext = (
  sandbox,
  { fallbackSandboxId = null, instancePreviewMode = null } = {}
) => {
  if (sandbox?.sandbox_id) {
    return {
      sandbox_id: sandbox.sandbox_id,
      active_overlay_id: sandbox.active_overlay_id || sandbox.overlay_id || null,
      workspace_snapshot_key:
        sandbox.workspace_snapshot_key || sandbox.active_workspace_snapshot_key || null,
      baseline_workspace_snapshot_key: sandbox.baseline_workspace_snapshot_key || null,
      parent_environment_snapshot_id: sandbox.parent_environment_snapshot_id || null,
      source_session_id: sandbox.source_session_id || null,
      ...(instancePreviewMode ? { instance_preview_mode: instancePreviewMode } : {}),
    };
  }

  const fallbackId = readString(fallbackSandboxId);
  if (!fallbackId) return null;

  // Keep preview overlay resolution active while the sandbox list is still loading.
  return {
    sandbox_id: fallbackId,
    ...emptySandboxContextFields(),
    ...(instancePreviewMode ? { instance_preview_mode: instancePreviewMode } : {}),
  };
};

/** Fresh OS Branch revision receipts override stale list metadata. */
export const mergeSandboxContextHints = (baseContext, hints) => {
  if (!baseContext || !hints || typeof hints !== 'object') return baseContext;
  if (hints.sandbox_id && hints.sandbox_id !== baseContext.sandbox_id) return baseContext;

  const merged = { ...baseContext };
  for (const key of [
    'active_overlay_id',
    'workspace_snapshot_key',
    'baseline_workspace_snapshot_key',
    'parent_environment_snapshot_id',
    'source_session_id',
    'sandbox_name',
  ]) {
    if (hints[key]) merged[key] = hints[key];
  }
  return merged;
};
